import axios from '@/axios/index'
export default {
  getLabelCommon(method, url, param = {}, item) {
    return axios[method || 'get'](url, param).then(res => {
      let data = res.data || []
      if (data.constructor === Object) data = data.items
      return {
        id: item.flagKey,
        data: this.getDataHandle(data || [], item.id || 'id', item.name || 'name', item.isLimit)
      }
    })
  },
  // 筛选条件集合处理
  filterChooseHandle(filterList, data) {
    // 初始化所有筛选条件集合
    data.forEach(res => {
      const filterObj = filterList.find(item => item.id === res.id)
      if (filterObj) {
        filterObj.children = res.data
        filterObj.intValue = res.intValue || filterObj.intValue || ''
      }
    })
    // 初始化当前选择的筛选条件
    const filterChooseObj = {}
    filterList.forEach(item => {
      if (item.type === 'select' && item.clearable) {
        item.intValue = item.children.length ? item.children[0].id : ''
      }
      if (item.id) filterChooseObj[item.id] = item.intValue || ''
      if (item.type === 'datesRange') {
        filterChooseObj[item.id + 'StartTime'] = ''
        filterChooseObj[item.id + 'EndTime'] = ''
      }
    })
    return {
      filterList,
      filterChooseObj
    }
  },
  // 所有筛选条件返回数据处理
  getDataHandle(data, key, value, isLimit) {
    const result = data.map(item => {
      // const obj = {
      //   id: (item[key || 'id'] + '') || '',
      //   name: item[value || 'name'] || ''
      // }
      // if (item.level) obj.level = item.level
      // return obj
      item.id = item[key || 'id'] || ''
      item.name = item[value || 'name'] || ''
      return item
    })
    if (isLimit) {
      result.unshift({
        id: '',
        name: '不限',
        isShow: 1
      })
    }
    return result
  },
  // 参数特殊处理，通过key找到对应的文字传参
  getTxtByKey(key, value) {
    const obj = this.filterList.find(item => item.id === key)
    if (obj.children) {
      const currentObj = obj.children.find(item => item.id === value) || { name: '不限' }
      const name = currentObj.name === '不限' ? '' : currentObj.name
      return name || value
    }
  },
  // 获取其他时间的值
  getOtherTime(date, otherDateTxt, filterList, id) {
    let newDate = date
    if (date === otherDateTxt) {
      const yearFilter = filterList.find(item => item.id === id)
      const otherYearId = yearFilter.children.reduce((preStr, item) => {
        if (item.id !== otherDateTxt) {
          preStr += item.id + ','
        }
        return preStr
      }, '')
      newDate = otherYearId.substr(0, otherYearId.length - 1)
    }
    return newDate
  },
  // 时间数组参数处理
  dateRangeParam(dateRange, startKey = 'startTime', endKey = 'endTime') {
    const obj = {}
    obj[startKey] = dateRange && dateRange.length ? dateRange[0] : ''
    obj[endKey] = dateRange && dateRange.length ? dateRange[1] : ''
    return obj
  },
  /*
  * 树形二级请求数据处理
  * pid：父级id
  * type: 父级key
  * data: 二级数据
  * navItem: 导航对象数据
  * isLeaf是否是叶子，没有子级
  */
  treeDataHandle(pid, type, data, navItem, isLeaf) {
    const treeList = data.reduce((preArr, item) => {
      item.key = item.id
      item.type = type
      item.pid = pid
      item.id = item.name
      item.leaf = isLeaf || item.hasNoChild
      if (item.name) preArr.push(item)
      return preArr
    }, [])
    // 如果pid不存在则，返回数据
    if (!pid) return treeList
    // 赋值给原数据
    const index = navItem.children.findIndex(item => item.key === pid)
    if (index >= 0) {
      const obj = navItem.children[index]
      obj.children = treeList
    }
    return navItem
  }
}
